import React, { Component, Fragment } from "react";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";

import Table from "./../../components/general/Table/Table";
import CredentialForm from "./../../components/page/credential/CredentialForm/CredentialForm";
import EditCredentialModal from "./../../components/page/credential/EditCredentialModal/EditCredentialModal";

class CredentialPage extends Component {
  state = {
    tableData: [],
    tableHeaders: [],
    showEditModal: false,
    credentialData: null,
    userId: null
  };

  toggleModal = (data) => {
    if (this.state.showEditModal) {
      this.setState({
        showEditModal: false,
        credentialData: null
      });
    } else {
      this.setState({
        showEditModal: true,
        credentialData: data
      });
    }
  };

  getCredentialData = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/${id}/credential`, {withCredentials: true})
      .then((response) => {
        let headers = ["id", "Name", "Company", "Email"];
        let credentials = response.data.credentials.map((credential, index) => {
          return [credential.credential_id, credential.name, credential.company, credential.email];
        });
        // sort credentials by name alphabetically ascending
        credentials = credentials.sort((a, b) => {
          let first = a[1].toUpperCase();
          let second = b[1].toUpperCase();
          return (first === "") - (second === "") || +(first > second) || -(first < second);
        });
        this.setState({
          tableHeaders: headers,
          tableData: credentials,
          userId: id
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    this.getCredentialData(this.props.match.params.id);
  }

  render() {
    let credentialTableButtons = [
      {
        display: "Edit",
        onClickHandler: (index) => {
          this.toggleModal(this.state.tableData[index]);
        }
      },
      {
        display: "Delete",
        onClickHandler: (index, id) => {
          if (
            window.confirm(
              `Are you sure you want to delete the credentials: ${this.state.tableData[index][1]}?\nThis action is irreversible.`
            )
          ) {
            axios
              .delete(`${process.env.REACT_APP_API_HOST}/credential/${id}`, {withCredentials: true})
              .then((res) => {
                if (res.status === 200) {
                  alert(`The credentials for ${this.state.tableData[index][1]} was deleted.`);
                  this.getCredentialData(this.state.userId);
                }
              })
              .catch((err) => console.log(err));
          }
        }
      }
    ];
    return (
      <Fragment>
        <Helmet>
          <title>Boxi Admin | Credentials</title>
        </Helmet>
        <Row className="mb-4">
          <Col lg="12" className="mb-4">
            <CredentialForm refresh={this.getCredentialData} userId={this.state.userId} />
          </Col>
          <Col lg="12">
            <Table
              id="credential-table"
              title="Credentials"
              buttons={credentialTableButtons}
              headers={this.state.tableHeaders}
              data={this.state.tableData}
            ></Table>
          </Col>
        </Row>
        <EditCredentialModal show={this.state.showEditModal} toggleModal={this.toggleModal} data={this.state.credentialData} userId={this.state.userId}/>
      </Fragment>
    );
  }
}

export default CredentialPage;
